import { usePriceFromDetails } from 'frontend/components/hooks/packages';
import React, { Fragment } from 'react';

export default function PriceFromDetails() {
  const [getPriceInformation, getFinalPrice] = usePriceFromDetails();
  const priceInformation = getPriceInformation();
  const finalPrice = getFinalPrice(true);

  return (
    <Fragment>
      <span className='moneda'>{priceInformation.moneda}</span>
      &nbsp;
      {finalPrice}
    </Fragment>
  );
}
